import { Strategy } from 'utility-ts-strategy';
import * as _4 from 'lodash4';
import { QuickScheduleFacade } from '../../facades/quick_schedule_facade';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { RegistrationFacade } from '../../../../registration/facades/registration_facade';
import { RegistrationPinsPermissionFacade } from '../../../../registration/facades/registration_pins_permission_facade';
import { SchedulerNavigationMenuQuery } from '../../queries/scheduler_navigation_menu_query';
import { PayTuitionFacade } from '../../../../registration/facades/pay_tuition_facade';
import { GetAppointmentScheduleLabelCommand } from '../../commands/get_appointment_schedule_label_command';
import { SelectedSectionActionsFacade } from '../../../../course_scheduler/facades/selected_section_actions_facade';
import { RequestStateQuery } from '../../../../../request_state/queries/request_state_query';

class SchedulerNavigationMenu {
  private registrationPrecheckUpdatedBound: any;
  private saveTermPinAndContinueBound: any;

  constructor(
    private $state: ng.ui.IStateService,
    private ngComponentCommunicatorService: CommunicatorService,
    private ngRegistrationFacade: RegistrationFacade,
    private ngRegistrationPinsPermissionFacade: RegistrationPinsPermissionFacade,
    private ngSchedulerNavigationMenuQuery: SchedulerNavigationMenuQuery,
    private ngPayTuitionFacade: PayTuitionFacade,
    private ngSelectedSectionActionsFacade: SelectedSectionActionsFacade,
    private ngQuickScheduleFacade: QuickScheduleFacade,
    private $element: ng.IAugmentedJQuery,
    private $timeout: ng.ITimeoutService,
    private getAppointmentScheduleLabelCommand: GetAppointmentScheduleLabelCommand,
    private ngRequestStateQuery: RequestStateQuery
  ) {
    this.registrationPrecheckUpdatedBound = this.ngRegistrationFacade.registrationPrecheckUpdated;
    this.saveTermPinAndContinueBound = this.ngRegistrationFacade.saveTermPinAndContinue;
  }

  $onInit() {
    this.ngComponentCommunicatorService.subscribe(
      'REGISRATION_PRE_CHECK_SUCCESS',
      this.registrationPrecheckUpdatedBound
    );
    this.ngComponentCommunicatorService.subscribe('REGISRATION_PRE_CHECK_FAIL', this.registrationPrecheckUpdatedBound);
    this.ngComponentCommunicatorService.subscribe('SAVE_TERM_PIN_AND_CONTINUE', this.saveTermPinAndContinueBound);
    this.getAppointmentScheduleLabelCommand();
  }

  $onDestroy() {
    this.ngComponentCommunicatorService.release('REGISRATION_PRE_CHECK_SUCCESS', this.registrationPrecheckUpdatedBound);
    this.ngComponentCommunicatorService.release('REGISRATION_PRE_CHECK_FAIL', this.registrationPrecheckUpdatedBound);
    this.ngComponentCommunicatorService.release('SAVE_TERM_PIN_AND_CONTINUE', this.saveTermPinAndContinueBound);
  }

  private readonly __menuItemStrategy = new Strategy({
    switchTerm: (value) => this.__onSwitchTerm(value),
    myPlannedCourses: () => this.$state.go('my.schedule.registration'),
    searchForSections: () => this.$state.go('my.schedule.registration.search'),
    searchForCourses: () => this.$state.go('my.schedule.searchandaddcourses'),
    transactionHistory: () => this.$state.go('my.schedule.transactions'),
    scheduleAppointmentDesktop: () => window.open(`${window.location.origin}/app/#/my/host/as3/appointment-new`),
    scheduleAppointmentMobile: () => window.location.assign('#/my/host/as3/appointment-new'),
    quickSchedule: () => this.ngQuickScheduleFacade.quickScheduleAction(),
    preferences: () => this.$state.go('my.schedule.registration.preferences'),
    sectionPin: () => this.ngRegistrationPinsPermissionFacade.onEnterSectionPinsTriggerEnded(),
    termPin: () => this.ngRegistrationPinsPermissionFacade.onEnterTermPinsTriggerEnded(),
    payTuition: () => this.ngPayTuitionFacade.onPayTuitionTriggerEnded(),
    registrationPortal: () => this.ngRegistrationFacade.onRegisterPortalTriggerEnded(),
    registerSections: () => this.ngRegistrationFacade.beginRegistration(),
    dropSections: () => this.ngSelectedSectionActionsFacade.openMultiSectionsActionModal('drop'),
    withdrawSections: () => this.ngSelectedSectionActionsFacade.openMultiSectionsActionModal('withdraw'),
    waitlistSections: () => this.ngSelectedSectionActionsFacade.openMultiSectionsActionModal('waitlist')
  });

  // SGD-21826 We should reload the same state only when the user is in Search Course or Search for sections
  __onSwitchTerm(termId: number) {
    const state = this.$state.current; // Get the current state
    const stateName = state.name; // Get the name of the current state

    // Check if the state or stateName is undefined or empty
    if (!state || _4.isEmpty(state) || !stateName || _4.isEmpty(stateName)) {
      // If any of the checks fail, redirect to the current state with the new termId and force a reload
      return this.$state.go(state, { termId }, { reload: true });
    }

    // Define the main registration state
    const regState = 'my.schedule.registration';

    // Define a substring of the registration state for easier checking
    const regSubState = `${regState}.`;

    // Check if the current state includes the registration substring
    const isRegSubState = stateName.includes(regSubState);

    // Define the specific registration search state
    const regSearchSectionSubState = `${regSubState}search`;

    // Check if the current state is exactly the registration search state
    const isRegSearchSectionSubState = stateName === regSearchSectionSubState;

    // Determine whether to reload based on the current state
    const shouldWeReload = isRegSubState ? isRegSearchSectionSubState : true;

    // Determine the state to redirect to based on whether we should reload
    const redirectionState = shouldWeReload ? stateName : regState;

    // Redirect to the determined state with the new termId and force a reload
    return this.$state.go(redirectionState, { termId }, { reload: true });
  }

  menuSelectedEnded($event: CustomEvent) {
    this.$timeout(() => {
      const [selectedAction, value] = _4.split($event.detail.value, '-');
      const invokeMenuStrategy = this.__menuItemStrategy.get(selectedAction);
      invokeMenuStrategy(value);
    });
  }

  openMenu() {
    const menu = this.$element[0].querySelector('hi-menu') as HTMLElement;
    const menuButton = this.$element[0].querySelector('hi-button') as HTMLElement;
    if (!menu || !menuButton) {
      return;
    }
    if (!menuButton.getAttribute('locked')) {
      menu['activate']();
    }
  }
}

angular.module('capability-ng-scheduler').component('schedulerNavigationMenu', {
  templateUrl:
    'capability-ng-scheduler/src/views/aside/scheduler_navigation/components/scheduler_navigation_menu/scheduler_navigation_menu.html',
  controller: SchedulerNavigationMenu
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/aside/scheduler_navigation/components/scheduler_navigation_menu/scheduler_navigation_menu.ts